import { render, staticRenderFns } from "./olderInfor.vue?vue&type=template&id=cc60fef6&scoped=true"
import script from "./olderInfor.vue?vue&type=script&lang=js"
export * from "./olderInfor.vue?vue&type=script&lang=js"
import style0 from "./olderInfor.vue?vue&type=style&index=0&id=cc60fef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc60fef6",
  null
  
)

export default component.exports